import React, { useState, useEffect } from "react";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import "./Packages.css";

// components imports
import PackagesList from "./Components/Packages/PackagesList";
import BundlesList from "./Components/Bundles/BundlesList";

// apis imports
// library imports
import { initialPackagesTab } from "../../../../../data/permissionsArray";
import { limitsTabsByPermission } from "../../../../../helpers/storeAccess";
import { useSelector } from "react-redux";
import TabsComponent from "../../../../../Components/Common/TabsComponent";
import { useTranslation } from "react-i18next";

// Tab labels by tab value; the English stays as written in permissionsArray.
const TAB_KEYS = { 0: "packages.tabs.packages", 1: "packages.tabs.bundles" };

const Packages = () => {
  const { t } = useTranslation("products");
  const user = useSelector((state) => state.user);

  const [tab, setTab] = useState(0);
  const [tabPermissions, setTabPermissions] = useState(initialPackagesTab);

  const setSnack = useSnackBar();

  useEffect(() => {
    if (limitsTabsByPermission(user)) {
      let validPermissions = initialPackagesTab.filter((t) =>
        user?.mergedPermissions?.includes(t.name),
      );
      if (validPermissions?.length > 0) {
        setTab(validPermissions[0]?.value);
      } else {
        setTab("nothing");
      }
      setTabPermissions(validPermissions);
    } else {
      setTab(0);
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "0px 5px" }}
    >

      <TabsComponent
        tab={tab}
        handleTabChange={handleTabChange}
        items={tabPermissions.map((item) => ({
          ...item,
          label: t(TAB_KEYS[item.value], { defaultValue: item.label }),
        }))}
      />

      {tab === 0 && <PackagesList setSnack={setSnack} />}
      {tab === 1 && <BundlesList setSnack={setSnack} />}
    </div>
  );
};

export default Packages;
